import { Pagination as BsPagination } from 'react-bootstrap'


export default function Paginator({
    page,
    totalPages,
    onChange,
    windowSize = 2,
    className = '',
    size,
}) {
    if (!totalPages || totalPages <= 1) return null

    const safePage = Math.min(Math.max(1, page || 1), totalPages)

    const from = Math.max(1, safePage - windowSize)
    const to   = Math.min(totalPages, safePage + windowSize)

    const items = []
    for (let i = from; i <= to; i++) items.push(i)

    const go = (p) => {
        if (p < 1 || p > totalPages || p === safePage) return
        onChange?.(p)
    }

    return (
        <div className={`d-flex justify-content-center mt-3 ${className}`}>
            <BsPagination size={size} className="mb-0">
                <BsPagination.First
                    disabled={safePage === 1}
                    onClick={() => go(1)}
                />
                <BsPagination.Prev
                    disabled={safePage === 1}
                    onClick={() => go(safePage - 1)}
                />

                {from > 1 && (
                    <>
                        <BsPagination.Item onClick={() => go(1)}>1</BsPagination.Item>
                        {from > 2 && <BsPagination.Ellipsis disabled />}
                    </>
                )}

                {items.map(p => (
                    <BsPagination.Item
                        key={p}
                        active={p === safePage}
                        onClick={() => go(p)}
                    >
                        {p}
                    </BsPagination.Item>
                ))}

                {to < totalPages && (
                    <>
                        {to < totalPages - 1 && <BsPagination.Ellipsis disabled />}
                        <BsPagination.Item onClick={() => go(totalPages)}>
                            {totalPages}
                        </BsPagination.Item>
                    </>
                )}

                <BsPagination.Next
                    disabled={safePage === totalPages}
                    onClick={() => go(safePage + 1)}
                />
                <BsPagination.Last
                    disabled={safePage === totalPages}
                    onClick={() => go(totalPages)}
                />
            </BsPagination>
        </div>
    )
}
